import { medicalsApi } from "../api/medicalsApi";
import { SOCIAL_HISTORY_QUESTIONNAIRE_CODE } from "../pages/health/encounters/cards/history/HistoryHelpers";
import { Reference } from "../types/reference";
import { SocialHistoryQuestionnaire } from "../types/socialHistory";
import { FHIRURL } from "../utils/FHIRURL";

const findSocialHistory = async (
  encounterReference: Reference,
  patientReference: Reference,
) => {
  const questionnaire = await medicalsApi.findQuestionnaireResponse(
    SOCIAL_HISTORY_QUESTIONNAIRE_CODE,
    {
      subject: patientReference.identifier,
      e: encounterReference?.identifier,
      "exclude-status": "entered-in-error",
    },
  );

  if (!Array.isArray(questionnaire) || questionnaire.length !== 1) {
    console.log("Physical assessment questionnaire not found");
    return;
  }

  return questionnaire[0];
};

const findQuestionnaire = async (): Promise<SocialHistoryQuestionnaire> => {
  const ENTITY_TYPE = "questionnaire";
  const questionnaire = await medicalsApi.findEntities(
    { code: SOCIAL_HISTORY_QUESTIONNAIRE_CODE, status: "active" },
    ENTITY_TYPE,
  );

  if (!Array.isArray(questionnaire) || questionnaire.length !== 1) {
    throw new Error(
      "Social history questionnaire is either more than or less than 1",
    );
  }

  return questionnaire[0];
};

const createDefault = (
  questionnaire: SocialHistoryQuestionnaire,
  encounterReference: Reference,
  patientReference: Reference,
  authoredDate: Date,
  practitionerReference: Reference,
) => {
  return {
    ...questionnaire,
    questionnaire: new FHIRURL(`Questionnaire/${questionnaire.id}`, {
      version: questionnaire.version,
      code: questionnaire.code[0]?.code,
    }).url,
    encounter: encounterReference,
    patient: patientReference,
    authoredDate: authoredDate,
    author: practitionerReference,
  };
};

export const SocialHistoryManager = {
  findSocialHistory,
  findQuestionnaire,
  createDefault,
};
